import { render, staticRenderFns } from "./menuMobile.vue?vue&type=template&id=3f52fc44&scoped=true&"
import script from "./menuMobile.vue?vue&type=script&lang=js&"
export * from "./menuMobile.vue?vue&type=script&lang=js&"
import style0 from "./menuMobile.vue?vue&type=style&index=0&id=3f52fc44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f52fc44",
  null
  
)

export default component.exports